module.exports = __webpack_public_path__ + "img/whats.1a9ad427.png";